<template>
  <div class="vip-wrapper">
    <basis-nav
      nav-title="会员中心"
      :back="back"
    />
    <div class="vip-card">
      <p class="end-date">有效期至 2020-02-02</p>
      <p class="name">{{ vip.name }}</p>
      <p class="worth">¥ <span v-money="vip.cashNeeded" class="money" /></p>
    </div>
    <div class="vip-related-wrapper">
      <div v-if="organization.moduleCourses.enable" class="related" @click="clickRelatedHandler('courses')">
        {{ vip.coursesCount }}
        <p class="label">{{ organization.moduleCourses.title }}</p>
      </div>
      <div v-if="organization.moduleNews.enable" class="related" @click="clickRelatedHandler('videos')">
        {{ vip.videosCount }}
        <p class="label">{{ organization.moduleNews.title }}</p>
      </div>
    </div>
    <div class="button-wrapper">
      <template v-if="vip.expired || vip.expired == null">
        <van-button class="cash" @click="payHandler">
          在线支付 ¥
          <span v-money="vip.cashNeeded" class="money" />
        </van-button>
      </template>
      <template v-else>
        <van-button class="cash-expired">
          {{ vip.expiredAt | dateFormat }} 前有效
        </van-button>
      </template>
    </div>
    <div class="overlay-wrapper">
      <wx-pay-overlay
        :overlay-status.sync="showWxPayOverlay"
        :qrcode="wxPayQrcode"
        @successed="$router.push({name: 'orders'})"
      />
    </div>
  </div>
</template>

<script>
import { BasisNav } from '@/components/basis'
import WxPayOverlay from '@/components/wx'
import { isWechatBrowser, onBridgeReady } from '@/utils/wechat'
import { wxPayENV } from '@/config/wx.config'
import { mapGetters } from 'vuex'
import { Orders } from '@/api'
import { mixinWxShare } from '@/mixins'

export default {
  name: 'Vip',
  components: { BasisNav, WxPayOverlay },
  mixins: [mixinWxShare],
  data: () => ({
    showWxPayOverlay: false,
    wxPayQrcode: ''
  }),
  computed: {
    ...mapGetters(['organization', 'vip'])
  },
  methods: {
    back () {
      // HACK: 并不能知道是从哪个页面来到的 VIP 页
      this.$router.go(-1)
    },
    async payHandler () {
      try {
        const { id } = this.$route.params
        const { order } = await Orders.add({
          collection: 'vips',
          resourceId: id
        })
        const { wxPayPayload, wxPayQrcode, wxPayUrl } = await Orders.pay({
          payType: 'cash',
          id: order.id
        })
        switch (isWechatBrowser()) {
          case true:
            // 微信浏览器
            onBridgeReady(wxPayPayload).then(() => {
              this.$notify({ type: 'success', message: '充值成功' })
              this.$router.go(-1)
            }).catch(() => {
              this.$notify({ type: 'danger', message: '充值失败' })
            })
            break
          case false:
            // 普通浏览器
            this.showWxPayOverlay = true
            if (wxPayENV === 'NATIVE') {
              this.wxPayQrcode = wxPayQrcode
            } else {
              window.location = wxPayUrl
            }
            break
        }
      } catch (error) {
        console.log(error)
      }
    },
    clickRelatedHandler (related) {
      this.$router.push({
        name: 'vip-related',
        params: {
          vipId: this.vip.id
        },
        query: {
          related
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.vip-wrapper {
  @include mh-bgc(100vh, #2B2D2F);
  .basis-nav {
    ::v-deep {
      .van-nav-bar {
        background-color: transparent;
        &::after {
          border-color: transparent;
        }
        .van-nav-bar__left {
          .van-icon {
            color: #fff;
          }
          .van-nav-bar__text {
            color: #fff;
          }
        }
        .van-ellipsis {
          color: #fff;
        }
      }
    }
  }
  .vip-card {
    @include wh(100%, 175px);
    @include bg-image-png('/vip/vip-card');
    padding: 20px 43px;
    margin: 25px auto;
    background-size: 343px 175px;
    background-position: center;
    background-repeat: no-repeat;
    color: #BF8736;
    .end-date {
      @include sc($font-size-md, inherit);
      padding-bottom: 16px;
    }
    .name {
      @include sc(27px, inherit);
      @include lw(32px, 600);
      @include ellipsis(2, 32px);
      @include wh(100%, 57px);
      margin-bottom: 32px;
    }
    .worth {
      @include sc($font-size-base, inherit);
      .money {
        @include sc($font-size-lg, inherit);
        @include lw(16px, 600);
      }
    }
  }
  .vip-related-wrapper {
    @include sc($font-size-md, #fff);
    @include lw(16px, 600);
    padding: 24px 16px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    text-align: center;
    .related {
      border: 1px solid transparent;
      + .related {
        border-left-color: rgba(255, 255, 255, 0.1);
      }
      .label {
        font-weight: 400;
        margin-top: 8px;
      }
    }
  }
  .button-wrapper {
    @include bottomfix(32px, 0);
    padding: 0 16px;
    .cash {
      @include normal-button(343px, 39px);
      @include lg-radius(#ECCEA2, #E7B170, 4px);
      font-size: $font-size-lg;
    }
    .cash-expired {
      @include normal-button(343px, 39px);
      @include lg-radius(#D9D9D9, #A2A2A2, 4px);
      font-size: $font-size-lg;
      border-color: transparent;
    }
  }
}
</style>
